import { LoadingButton } from "@mui/lab";
import { Box, Button, Modal, Stack, Typography } from "@mui/material";
import React from "react";

function ModalDeleteProject({
  modalOpen,
  setModalOpen,
  loadingButtonDelete,
  handlerDeleteProject,
}) {
  return (
    <Modal open={modalOpen} onClose={() => setModalOpen(false)}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 300,
          bgcolor: "white",
          borderRadius: 3,
          boxShadow: 4,
          p: 2,
        }}
      >
        <Typography component="h2" variant="h5" mb={1}>
          Confirmación
        </Typography>
        <Typography mb={2}>¿Quieres eliminar este proyecto?</Typography>
        <Stack flexDirection="row" justifyContent="flex-end">
          <Button
            sx={{ mr: 1.5 }}
            onClick={() => setModalOpen(false)}
            disabled={loadingButtonDelete ? true : false}
          >
            CANCELAR
          </Button>
          <LoadingButton
            loading={loadingButtonDelete}
            variant="contained"
            sx={{ color: "white" }}
            onClick={handlerDeleteProject}
          >
            CONFIRMAR
          </LoadingButton>
        </Stack>
      </Box>
    </Modal>
  );
}

export default ModalDeleteProject;
